<template>
  <div class="column is-6 pdt-0 level-right">
    <div class="columns">
      <div class="column is-4"
           v-for="(faceInfo, index) in facesInformations" :key="index">
        <div class="card">
          <div class="card-content pd-10px">
            <p class="has-text-default"> {{ faceInfo.title }} </p>
            <p class="has-text-link has-text-weight-bold"> {{ faceInfo.nb }} </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    demande: {
      type: Object,
      required: true,
    },
  },
  computed: {
    facesInformations() {
      return [
        {
          title: this.$i18n.t('listeDemande.faces.vendues'),
          nb: this.demande.quantiteFacesVendues ? this.demande.quantiteFacesVendues : 0,
        },
        {
          title: this.$i18n.t('listeDemande.faces.affectees'),
          nb: this.demande.quantiteFacesAffectees ? this.demande.quantiteFacesAffectees : 0,
        },
        {
          title: this.$i18n.t('listeDemande.faces.aAffecter'),
          nb: this.demande.quantiteFacesAAffecter ? this.demande.quantiteFacesAAffecter : 0,
        },
      ];
    },
  },
};

</script>
